import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  constructor(
    private http: HttpClient
  ) { }

  GetTimestamp(): Observable<number>{ 
    return this.http.get<number>(environment.apiUrl + "time.php");
  }
}
